import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      appName: 'LiveBetter Hub',
      nav: {
        home: 'Home',
        buildings: 'Buildings',
        services: 'Services',
        dataExchange: 'Data Exchange',
        wikiAssistant: 'Wiki',
        settings: 'Settings',
        logout: 'Logout',
      },
      common: {
        loading: 'Loading...',
        connectWallet: 'Connect Wallet',
      },
    },
  },
  el: { translation: { appName: 'LiveBetter Hub', nav: { home: 'Αρχική', buildings: 'Κτίρια', services: 'Υπηρεσίες', dataExchange: 'Ανταλλαγή Δεδομένων', wikiAssistant: 'Wiki', settings: 'Ρυθμίσεις', logout: 'Αποσύνδεση' }, common: { loading: 'Φόρτωση...', connectWallet: 'Σύνδεση Πορτοφολιού' } } },
  es: { translation: { appName: 'LiveBetter Hub', nav: { home: 'Inicio', buildings: 'Edificios', services: 'Servicios', dataExchange: 'Intercambio de Datos', wikiAssistant: 'Wiki', settings: 'Configuración', logout: 'Salir' }, common: { loading: 'Cargando...', connectWallet: 'Conectar Billetera' } } },
  hu: { translation: { appName: 'LiveBetter Hub', nav: { home: 'Kezdőlap', buildings: 'Épületek', services: 'Szolgáltatások', dataExchange: 'Adatcsere', wikiAssistant: 'Wiki / Asszisztens', settings: 'Beállítások', logout: 'Kijelentkezés' }, common: { loading: 'Betöltés...', connectWallet: 'Pénztárca Csatlakoztatása' } } },
  lv: { translation: { appName: 'LiveBetter Hub', nav: { home: 'Sākums', buildings: 'Ēkas', services: 'Pakalpojumi', dataExchange: 'Datu Apmaiņa', wikiAssistant: 'Wiki / Asistents', settings: 'Iestatījumi', logout: 'Iziet' }, common: { loading: 'Ielāde...', connectWallet: 'Pievienot Maku' } } },
  bg: { translation: { appName: 'LiveBetter Hub', nav: { home: 'Начало', buildings: 'Сгради', services: 'Услуги', dataExchange: 'Обмен на Данни', wikiAssistant: 'Wiki / Асистент', settings: 'Настройки', logout: 'Изход' }, common: { loading: 'Зареждане...', connectWallet: 'Свържи Портфейл' } } },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;

